import { WrenchTheme } from '@wds/styles';
import { convertToObject } from '~shared/util';

const DISPLAY_SIZE_OPTIONS_DATA = Object.freeze(['default', 'sm', 'mds-sm', 'md', 'lg', 'xl', 'xs', 'none']);

export const SIZE_OPTIONS: { [key: string]: string } = convertToObject(...DISPLAY_SIZE_OPTIONS_DATA);

export type DisplaySizeOption = (typeof DISPLAY_SIZE_OPTIONS_DATA)[number];
export type DisplaySizeOptions = Record<DisplaySizeOption, number | string>;

const DISPLAY_SIZE_OPTIONS: Required<DisplaySizeOptions> = {
  default: 'default',
  sm: WrenchTheme.breakpoints.sm,
  'mds-sm': 320,
  md: WrenchTheme.breakpoints.md,
  lg: WrenchTheme.breakpoints.lg,
  xl: WrenchTheme.breakpoints.xl,
  xs: WrenchTheme.breakpoints.xs,
  none: 'none',
};

export default DISPLAY_SIZE_OPTIONS;
